import { Link } from "react-router-dom";
import { CreditCard, Bitcoin, DollarSign, Wallet } from "lucide-react";
import { SocialLinks } from "./footer/SocialLinks";
import { Newsletter } from "./footer/Newsletter";
import { LanguageSelector } from "@/components/layout/navigation/LanguageSelector";
import { T } from "@/components/translation/T";

export const Footer = () => (
  <footer className="public-page public-footer w-full bg-muted/50 text-foreground border-t border-border mt-auto">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-10 sm:py-12">
      <div className="public-footer-columns">
        <div className="space-y-5">
          <Link to="/" aria-label="Sokoby — Accueil"><img src="/sokoby-official-logo.png" alt="Sokoby" width={614} height={251} className="sokoby-public-logo" loading="lazy" /></Link>
          <SocialLinks />
        </div>
        <div className="space-y-4">
          <h3 className="text-sm font-semibold"><T>Liens rapides</T></h3>
          <nav aria-label="Liens du pied de page" className="flex flex-col gap-3 text-sm text-muted-foreground">
            <Link to="/fonctionnalites"><T>Fonctionnalités</T></Link>
            <Link to="/tarifs"><T>Tarifs</T></Link>
            <Link to="/contact"><T>Contact</T></Link>
            <Link to="/support"><T>Support</T></Link>
          </nav>
        </div>
        <div className="space-y-4">
          <h3 className="text-sm font-semibold"><T>Informations légales</T></h3>
          <nav aria-label="Informations légales" className="flex flex-col gap-3 text-sm text-muted-foreground">
            <Link to="/legal"><T>Mentions légales</T></Link>
            <Link to="/legal/privacy"><T>Confidentialité</T></Link>
            <Link to="/conditions"><T>Conditions d'utilisation</T></Link>
            <Link to="/accessibility"><T>Accessibilité</T></Link>
          </nav>
        </div>
        <div className="space-y-7 public-footer-newsletter">
          <Newsletter />
          <div className="space-y-3">
            <h3 className="text-sm font-semibold"><T>Moyens de paiement acceptés</T></h3>
            <div className="flex gap-4 text-muted-foreground">
              <CreditCard className="h-5 w-5" /><DollarSign className="h-5 w-5" /><Bitcoin className="h-5 w-5" /><Wallet className="h-5 w-5" />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-4 mt-8 pt-5 border-t border-border text-xs text-muted-foreground">
        <p>© {new Date().getFullYear()} Sokoby. <T>Tous droits réservés</T></p>
        <LanguageSelector />
      </div>
    </div>
  </footer>
);
export default Footer;
